window.vueCheckout = new Vue({
	name: 'checkout',
	el: '#checkout',
	data: {
		existing_user: window.pageData.user_details ? true : false,
		first_name: window.pageData.user_details ? window.pageData.user_details.first_name : null,
		user_email: window.pageData.user_details ? window.pageData.user_details.user_email : null,
		confirm_user_email: null,
		opt_in: false,
		subscription_plan: window.pageData.plan ? window.pageData.plan : localStorage.getItem('lcSubscriptionPlan'),
		password: null,

		thinking: true,
		plan_detail: null,
		stripe_customer: window.pageData.stripe_customer ? window.pageData.stripe_customer : null,

		show_coupon: false,
		coupon: null,
		coupon_detail: null,
		discount_type: null,
		discount: 0,
		discount_text: null,
		error: false,

		processing_text: 'Processing',
		pay_button_text: null,
		success: false,
		device: false,

		continue_on_web: false,

		referral_code: null,
		show_referral: false,
		referral_code_applied: false,
	},

	watch: {
		continue_on_web(val) {
			if (val) {
				jQuery('.lc-show-pw').click(function() {
					document.querySelectorAll('#user_pass').forEach((input) => {
						if (input.type === 'password') input.type = 'text';
						else if (input.type === 'text') input.type = 'password';
					});
				});
			}
		},
	},

	computed: {
		user_subscriptions() {
			return this.stripe_customer ? this.stripe_customer.subscriptions.data : null;
		},

		user_active_subscription() {
			/* return this.stripe_customer
				? this.stripe_customer.subscriptions.data.some(function(subscription) {
						return subscription.status === 'active' || subscription.status === 'trialing';
				  })
				: null; */

				return false;
		},

		default_pay_button_text() {
			return !coreHelpers.getNested(this.user_active_subscription) &&
				this.user_subscriptions &&
				coreHelpers.getNested(this.user_subscriptions.length)
				? 'Sign up'
				: 'Start free trial';
		},

		discounted_total() {
			if (!this.discount_type) {
				return null;
			}

			let total = this.plan_detail ? this.plan_detail.amount / 100 : null;

			if (this.discount_type !== null && total) {
				if (this.discount_type === 'percent') {
					total = total - (this.discount / 100) * total;
				} else if (this.discount_type === 'amount') {
					total = total - this.discount / 100;
				}
			}

			return typeof total === 'number' ? total.toFixed(2) : null;
		},
	},

	mounted() {
		if (this.user_active_subscription) {
			return false;
		}

		if (this.subscription_plan) {
			this.elements = new LCStripe();
			this.cardElement = this.elements.createCard();
			this.cardElement.mount('#credit-card-stripe-element');

			localStorage.setItem('lcSubscriptionPlan', this.subscription_plan);

			this.getPlan(this.subscription_plan);
		}

		this.pay_button_text = this.default_pay_button_text;

		if (
			!coreHelpers.getNested(this.user_active_subscription) &&
			this.user_subscriptions &&
			coreHelpers.getNested(this.user_subscriptions.length)
		) {
			setTimeout(function() {
				coreVariables.triggerModal(
					'Trial',
					'It looks like you have previously had a free trial, by continuing your subscription fee will be charged today'
				);
			}, 4000);
		}
	},

	methods: {
		applyCoupon() {
			this.thinking = true;
			window.coreHelpers.ajax.call(
				this,
				'POST',
				'lc_get_coupon',
				{
					coupon_code: this.coupon, //coupon code
					referral_code: this.referral_code,
				},
				function(res) {
					if (res.success) {
						this.thinking = false;
						this.show_coupon = false;

						this.coupon_detail = coreHelpers.getNested(res, 'data', 'coupon');
						console.log('LC: coupon retreived', this.coupon_detail);

						this.discount_type = this.coupon_detail.percent_off ? 'percent' : 'amount';
						this.discount = this.coupon_detail.percent_off ? this.coupon_detail.percent_off : this.coupon_detail.amount_off;
						this.discount_text = this.coupon_detail.percent_off
							? this.coupon_detail.percent_off + '%'
							: (this.coupon_detail.amount_off / 100).toFixed(2) +
							  ' <span class="currency">' +
							  this.coupon_detail.currency +
							  '</span>';

						//apply the coupon to the checkout
						if (coreHelpers.getNested(res, 'data', 'coupon_type') === 'referral') {
							this.referral_code_applied = true;
							coreVariables.triggerModal(
								'Success',
								'Referral code applied - this gives you a ' + this.discount_text.toUpperCase() + ' discount'
							);
						} else {
							this.referral_code_applied = false;

							coreVariables.triggerModal(
								'Success',
								'Coupon code applied - this gives you a ' + this.discount_text.toUpperCase() + ' discount'
							);
						}
					} else {
						this.thinking = false;
						this.coupon_detail = null;
						coreVariables.triggerModal('Slight issue', 'This code is not valid');
					}
				},
				function(res) {
					this.thinking = false;
					this.coupon_detail = null;
					coreVariables.triggerModal('Slight issue', 'This code is not valid');
				}
			);
		},

		//triggered when pay button clicked
		process() {
			this.thinking = true;
			this.pay_button_text = this.processing_text;

			//form validation
			if (!this.existing_user) {
				if (!this.first_name || !this.user_email || !this.confirm_user_email || !this.password || !this.opt_in) {
					this.thinking = false;
					this.pay_button_text = this.default_pay_button_text;
					coreVariables.triggerModal('Checkout incomplete', 'All form fields are required');
					return false;
				}

				if (this.user_email !== this.confirm_user_email) {
					this.thinking = false;
					this.pay_button_text = this.default_pay_button_text;
					coreVariables.triggerModal("Email doesn't match", 'Both email fields must be identical');
					return false;
				}
			}

			//https://www.w3resource.com/javascript/form/password-validation.php
			let pwcheck = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;

			if (this.password && (!this.password.match(pwcheck) && this.password.indexOf(' ') === -1)) {
				this.thinking = false;
				this.pay_button_text = this.default_pay_button_text;
				coreVariables.triggerModal('Slight issue', 'Your password needs attention - see the requirements below the field');
				return false;
			}

			let billing_details = { email: this.user_email };

			if (this.first_name) {
				billing_details.name = this.first_name;
			}

			stripe
				.createPaymentMethod({
					type: 'card',
					card: this.cardElement,
					billing_details: billing_details,
				})
				.then(function(result) {
					console.log('LC: payment method created, triggering checkout', result);

					if (result.paymentMethod && !result.error) {
						coreHelpers.ajax.call(
							this,
							'POST',
							'lc_checkout',
							{
								payment_method: result.paymentMethod,
								subscription_plan: window.vueCheckout.subscription_plan,
								coupon:
									window.vueCheckout.coupon_detail !== null && window.vueCheckout.coupon_detail.valid
										? window.vueCheckout.coupon_detail.id
										: false,
								referral_code: window.vueCheckout.referral_code,

								user_details: {
									first_name: window.vueCheckout.first_name,
									user_email: window.vueCheckout.user_email,
									password: window.vueCheckout.password,
								},
							},
							window.vueCheckout.checkoutSuccess,
							window.vueCheckout.checkoutFailure
						);
					} else {
						if (result.error) {
							coreVariables.triggerModal('Slight issue', result.error.message);
						}

						window.vueCheckout.thinking = false;
						window.vueCheckout.pay_button_text = this.default_pay_button_text;
					}
				});
		},

		checkoutSuccess(res) {
			window.vueCheckout.thinking = false;

			if (res.success === true) {
				this.cardElement.destroy();

				//check the status of the subscription
				if (res.data.subscription.status === 'active' || res.data.subscription.status === 'trialing') {
					this.success = true;
					this.pay_button_text = this.default_pay_button_text;

					console.log('LC: subscription is now active or trialing');

					if (this.referral_code_applied) {
						coreHelpers.ajax.call(
							this,
							'POST',
							'lc_apply_discount_to_referrer',
							{
								referral_code: this.referral_code,
								subscription: res.data.subscription,
								stripe_customer: res.data.stripe_customer,
							},
							function(referralRes) {
								console.log('LC: referral processed', referralRes);
								window.lcGA('referral', 'code redeemed', this.referral_code);
							}
						);
					}

					window.lcGA('Checkout', 'Completed', coreHelpers.getNested(res, 'data', 'plan', 'id'));

					if (typeof fbq !== 'undefined') {
						fbq('track', 'Purchase');
					}

					if (typeof gtag !== 'undefined') {
						gtag('event', 'conversion', {
							send_to: 'AW-852866472/33ePCJbp0qQBEKjr1pYD',
							value: 1.0,
							currency: 'AUD',
							transaction_id: '',
						});
					}
				} else {
					this.pay_button_text = this.default_pay_button_text;
					coreVariables.triggerModal(
						'Slight issue',
						'We could not activate your subscription - please get in touch at support@lyndicohen.com'
					);
					console.log('LC: subscription was not activated', res);
				}
			} else {
				this.pay_button_text = this.default_pay_button_text;
				console.log('LC: fail', res.data.issue, res.responseText);
			}
		},

		checkoutFailure(res) {
			window.vueCheckout.thinking = false;
			window.vueCheckout.pay_button_text = this.default_pay_button_text;

			if (typeof res.data !== 'undefined') {
				console.log('LC: fail:' + res.data);

				if (typeof res.data.user_message !== 'undefined') {
					coreVariables.triggerModal('Slight issue', res.data.user_message);
				} else {
					coreVariables.triggerModal('Slight issue', 'Something has gone wrong, please try again');
				}

				if (typeof res.responseText !== 'undefined') {
					console.log('LC: fail:' + res.responseText);
				}
			}
		},

		getPlan() {
			window.coreHelpers.ajax.call(
				this,
				'POST',
				'lc_get_plan',
				{
					plan: this.subscription_plan,
				},
				function(res) {
					if (res.success) {
						this.thinking = false;
						window.vueCheckout.plan_detail = res.data;
						console.log('LC: plan retreived', res);
					} else {
						window.vueCheckout.plan_detail = false;
						window.vueCheckout.error = true;
						coreVariables.triggerModal('Slight issue', 'Could not find subscription plan - it may no longer exist');
					}
				},
				function() {
					window.vueCheckout.plan_detail = false;
					window.vueCheckout.error = true;
					coreVariables.triggerModal('Slight issue', 'Could not find subscription plan - it may no longer exist');
				}
			);
		},
	},
});
